/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScrapedPropertyContentItem } from './ScrapedPropertyContentItem';
import {
    ScrapedPropertyContentItemFromJSON,
    ScrapedPropertyContentItemFromJSONTyped,
    ScrapedPropertyContentItemToJSON,
    ScrapedPropertyContentItemToJSONTyped,
} from './ScrapedPropertyContentItem';

/**
 * Bulk request to save scraped property content
 * @export
 * @interface ScrapedPropertyContentBulkRequest
 */
export interface ScrapedPropertyContentBulkRequest {
    /**
     * Hotel chain name (e.g., marriott, hilton, hyatt)
     * @type {string}
     * @memberof ScrapedPropertyContentBulkRequest
     */
    chainName: string;
    /**
     * 
     * @type {Array<ScrapedPropertyContentItem>}
     * @memberof ScrapedPropertyContentBulkRequest
     */
    items: Array<ScrapedPropertyContentItem>;
}

/**
 * Check if a given object implements the ScrapedPropertyContentBulkRequest interface.
 */
export function instanceOfScrapedPropertyContentBulkRequest(value: object): value is ScrapedPropertyContentBulkRequest {
    if (!('chainName' in value) || value['chainName'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ScrapedPropertyContentBulkRequestFromJSON(json: any): ScrapedPropertyContentBulkRequest {
    return ScrapedPropertyContentBulkRequestFromJSONTyped(json, false);
}

export function ScrapedPropertyContentBulkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScrapedPropertyContentBulkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'chainName': json['chain_name'],
        'items': ((json['items'] as Array<any>).map(ScrapedPropertyContentItemFromJSON)),
    };
}

export function ScrapedPropertyContentBulkRequestToJSON(json: any): ScrapedPropertyContentBulkRequest {
    return ScrapedPropertyContentBulkRequestToJSONTyped(json, false);
}

export function ScrapedPropertyContentBulkRequestToJSONTyped(value?: ScrapedPropertyContentBulkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chain_name': value['chainName'],
        'items': ((value['items'] as Array<any>).map(ScrapedPropertyContentItemToJSON)),
    };
}

